import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { MpAdminActions } from "../../actions/mp-admin.actions";
import { AnalyticsExclusionState } from "../../models/mp-admin/analytics-exclusion-state";

const initialState: AnalyticsExclusionState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(MpAdminActions.analyticsExclusions.get, (state, action) =>
		_.set(_.cloneDeep(state), "loading", true)
	),
	on(MpAdminActions.analyticsExclusions.getSuccess, (state, action) => _.omit(action, "type")),
	on(MpAdminActions.analyticsExclusions.getFail, (state, action) => ({
		...state,
		..._.omit(action, "type")
	}))
);

export function analyticsExclusionReducer(
	state: AnalyticsExclusionState,
	action: Action
): AnalyticsExclusionState {
	return reducer(state, action);
}
